import { z } from "zod";
import {
  COMMUNITY_NAME,
  COMMUNITY_REGISTERED_NAME,
  LANGUAGE,
  UNITS,
  ADDRESS_1,
  ADDRESS_2,
  ZIPCODE,
  STATE,
  CITY,
  GENERAL_PHONE,
  EMERGENCY_PHONE,
  MANAGER_NAME,
  MANAGER_PHONE,
  CONTACT_EMAIL,
  WEBSITE,
  COUNTY,
  AUDIT_SCOPE,
  AUDIT_STATE,
  LICENSE_CATEGORY,
  ACCOUNTING_METHOD,
} from "./consts";

export const communitySchema = z.object({
  [COMMUNITY_NAME]: z
    .string()
    .min(3, "Please fill community Name")
    .max(30, "Community Name should be less than 30 characters"),
  [COMMUNITY_REGISTERED_NAME]: z
    .string()
    .optional()
    .refine((val) => !val || (val.length >= 3 && val.length <= 30), {
      message: "Must be between 3 and 30 characters",
    }),
  [LANGUAGE]: z.string().optional(),
  [UNITS]: z.string().optional(),
  [ADDRESS_1]: z.string().min(1, "Please fill address"),
  [ADDRESS_2]: z.string().optional(),
  [ZIPCODE]: z.string().regex(/^[0-9]{5}-[0-9]{4}$/, "Enter ZIP code in XXXXX-XXXX format."),
  [STATE]: z.string().min(1, "Please fill state"),
  [CITY]: z.string().min(1, "Please fill city"),
  [COUNTY]: z.string().min(1, "This field is required"),
  [AUDIT_SCOPE]: z.string().min(1, "This field is required"),
  [AUDIT_STATE]: z.string().optional(),
  [LICENSE_CATEGORY]: z.string().min(1, "This field is required"),
  [ACCOUNTING_METHOD]: z.string().min(1, "This field is required"),
  [GENERAL_PHONE]: z
    .string()
    .min(10, "Please fill general phone number")
    .regex(/^\+[1-9][0-9]{6,14}$/, "Invalid Phone Number")
    .optional(),
  [EMERGENCY_PHONE]: z
    .string()
    .min(10, "Please fill emergency phone number")
    .regex(/^\+[1-9][0-9]{6,14}$/, "Invalid Phone Number"),
  [MANAGER_NAME]: z.string().optional(),
  [MANAGER_PHONE]: z.string().optional(),
  [CONTACT_EMAIL]: z
    .string()
    .min(1, "Please fill contact email")
    .email("This is not a valid email."),
  [WEBSITE]: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!val) return true; // Skip validation if empty
        return /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)*$/.test(val);
      },
      {
        message: "Invalid URL",
      }
    ),
}).superRefine((data, context) => {
  if (data[AUDIT_SCOPE] === "STATE" && !data[AUDIT_STATE]) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: [AUDIT_STATE],
      message: "This field is required",
    });
  }
});

export type communityFormValues = z.infer<typeof communitySchema>;
